// Флаг-эмодзи из ISO-кода страны: "KZ" → 🇰🇿
const toFlag = (iso) => String.fromCodePoint(...[...iso].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));

// [ISO, название, телефонный код, маска номера без кода страны]
// Маска задана для частых стран; для остальных — просто цифры (до 14).
const POPULAR = [
  ["KZ", "Казахстан", "7", "000 000 0000"],
  ["RU", "Россия", "7", "000 000 0000"],
  ["UZ", "Узбекистан", "998", "00 000 0000"],
  ["KG", "Кыргызстан", "996", "000 000 000"],
  ["TJ", "Таджикистан", "992", "00 000 0000"],
  ["TM", "Туркменистан", "993", "00 000000"],
  ["AZ", "Азербайджан", "994", "00 000 0000"],
  ["AM", "Армения", "374", "00 000 000"],
  ["GE", "Грузия", "995", "000 000 000"],
  ["BY", "Беларусь", "375", "00 000 0000"],
  ["UA", "Украина", "380", "00 000 0000"],
  ["MD", "Молдова", "373", "00 000 000"],
  ["MN", "Монголия", "976", "0000 0000"],
  ["TR", "Турция", "90", "000 000 0000"],
  ["AE", "ОАЭ", "971", "00 000 0000"],
  ["SA", "Саудовская Аравия", "966", "00 000 0000"],
  ["QA", "Катар", "974", "0000 0000"],
  ["KW", "Кувейт", "965", "0000 0000"],
  ["BH", "Бахрейн", "973", "0000 0000"],
  ["OM", "Оман", "968", "0000 0000"],
  ["EG", "Египет", "20", "00 0000 0000"],
  ["CN", "Китай", "86", "000 0000 0000"],
  ["US", "США", "1", "000 000 0000"],
  ["GB", "Великобритания", "44", "0000 000000"],
];

const OTHERS = [
  ["AF", "Афганистан", "93"],
  ["AL", "Албания", "355"],
  ["DZ", "Алжир", "213"],
  ["AD", "Андорра", "376"],
  ["AO", "Ангола", "244"],
  ["AG", "Антигуа и Барбуда", "1268"],
  ["AR", "Аргентина", "54"],
  ["AU", "Австралия", "61", "000 000 000"],
  ["AT", "Австрия", "43"],
  ["BS", "Багамы", "1242"],
  ["BD", "Бангладеш", "880"],
  ["BB", "Барбадос", "1246"],
  ["BE", "Бельгия", "32"],
  ["BZ", "Белиз", "501"],
  ["BJ", "Бенин", "229"],
  ["BT", "Бутан", "975"],
  ["BO", "Боливия", "591"],
  ["BA", "Босния и Герцеговина", "387"],
  ["BW", "Ботсвана", "267"],
  ["BR", "Бразилия", "55"],
  ["BN", "Бруней", "673"],
  ["BG", "Болгария", "359"],
  ["BF", "Буркина-Фасо", "226"],
  ["BI", "Бурунди", "257"],
  ["KH", "Камбоджа", "855"],
  ["CM", "Камерун", "237"],
  ["CA", "Канада", "1", "000 000 0000"],
  ["CV", "Кабо-Верде", "238"],
  ["CF", "ЦАР", "236"],
  ["TD", "Чад", "235"],
  ["CL", "Чили", "56"],
  ["CO", "Колумбия", "57"],
  ["KM", "Коморы", "269"],
  ["CG", "Конго", "242"],
  ["CD", "ДР Конго", "243"],
  ["CR", "Коста-Рика", "506"],
  ["CI", "Кот-д’Ивуар", "225"],
  ["HR", "Хорватия", "385"],
  ["CU", "Куба", "53"],
  ["CY", "Кипр", "357"],
  ["CZ", "Чехия", "420"],
  ["DK", "Дания", "45"],
  ["DJ", "Джибути", "253"],
  ["DM", "Доминика", "1767"],
  ["DO", "Доминиканская Республика", "1809"],
  ["EC", "Эквадор", "593"],
  ["SV", "Сальвадор", "503"],
  ["GQ", "Экваториальная Гвинея", "240"],
  ["ER", "Эритрея", "291"],
  ["EE", "Эстония", "372"],
  ["SZ", "Эсватини", "268"],
  ["ET", "Эфиопия", "251"],
  ["FJ", "Фиджи", "679"],
  ["FI", "Финляндия", "358"],
  ["FR", "Франция", "33", "0 00 00 00 00"],
  ["GA", "Габон", "241"],
  ["GM", "Гамбия", "220"],
  ["GH", "Гана", "233"],
  ["DE", "Германия", "49"],
  ["GR", "Греция", "30"],
  ["GD", "Гренада", "1473"],
  ["GT", "Гватемала", "502"],
  ["GN", "Гвинея", "224"],
  ["GW", "Гвинея-Бисау", "245"],
  ["GY", "Гайана", "592"],
  ["HT", "Гаити", "509"],
  ["HN", "Гондурас", "504"],
  ["HK", "Гонконг", "852"],
  ["HU", "Венгрия", "36"],
  ["IS", "Исландия", "354"],
  ["IN", "Индия", "91", "00000 00000"],
  ["ID", "Индонезия", "62"],
  ["IR", "Иран", "98"],
  ["IQ", "Ирак", "964"],
  ["IE", "Ирландия", "353"],
  ["IL", "Израиль", "972"],
  ["IT", "Италия", "39"],
  ["JM", "Ямайка", "1876"],
  ["JP", "Япония", "81"],
  ["JO", "Иордания", "962"],
  ["KE", "Кения", "254"],
  ["KI", "Кирибати", "686"],
  ["KP", "КНДР", "850"],
  ["KR", "Южная Корея", "82"],
  ["XK", "Косово", "383"],
  ["LA", "Лаос", "856"],
  ["LV", "Латвия", "371"],
  ["LB", "Ливан", "961"],
  ["LS", "Лесото", "266"],
  ["LR", "Либерия", "231"],
  ["LY", "Ливия", "218"],
  ["LI", "Лихтенштейн", "423"],
  ["LT", "Литва", "370"],
  ["LU", "Люксембург", "352"],
  ["MO", "Макао", "853"],
  ["MG", "Мадагаскар", "261"],
  ["MW", "Малави", "265"],
  ["MY", "Малайзия", "60"],
  ["MV", "Мальдивы", "960"],
  ["ML", "Мали", "223"],
  ["MT", "Мальта", "356"],
  ["MH", "Маршалловы Острова", "692"],
  ["MR", "Мавритания", "222"],
  ["MU", "Маврикий", "230"],
  ["MX", "Мексика", "52"],
  ["FM", "Микронезия", "691"],
  ["MC", "Монако", "377"],
  ["ME", "Черногория", "382"],
  ["MA", "Марокко", "212"],
  ["MZ", "Мозамбик", "258"],
  ["MM", "Мьянма", "95"],
  ["NA", "Намибия", "264"],
  ["NR", "Науру", "674"],
  ["NP", "Непал", "977"],
  ["NL", "Нидерланды", "31"],
  ["NZ", "Новая Зеландия", "64"],
  ["NI", "Никарагуа", "505"],
  ["NE", "Нигер", "227"],
  ["NG", "Нигерия", "234"],
  ["MK", "Северная Македония", "389"],
  ["NO", "Норвегия", "47"],
  ["PK", "Пакистан", "92", "000 0000000"],
  ["PW", "Палау", "680"],
  ["PS", "Палестина", "970"],
  ["PA", "Панама", "507"],
  ["PG", "Папуа — Новая Гвинея", "675"],
  ["PY", "Парагвай", "595"],
  ["PE", "Перу", "51"],
  ["PH", "Филиппины", "63"],
  ["PL", "Польша", "48", "000 000 000"],
  ["PT", "Португалия", "351"],
  ["RO", "Румыния", "40"],
  ["RW", "Руанда", "250"],
  ["KN", "Сент-Китс и Невис", "1869"],
  ["LC", "Сент-Люсия", "1758"],
  ["VC", "Сент-Винсент и Гренадины", "1784"],
  ["WS", "Самоа", "685"],
  ["SM", "Сан-Марино", "378"],
  ["ST", "Сан-Томе и Принсипи", "239"],
  ["SN", "Сенегал", "221"],
  ["RS", "Сербия", "381"],
  ["SC", "Сейшелы", "248"],
  ["SL", "Сьерра-Леоне", "232"],
  ["SG", "Сингапур", "65", "0000 0000"],
  ["SK", "Словакия", "421"],
  ["SI", "Словения", "386"],
  ["SB", "Соломоновы Острова", "677"],
  ["SO", "Сомали", "252"],
  ["ZA", "ЮАР", "27"],
  ["SS", "Южный Судан", "211"],
  ["ES", "Испания", "34", "000 000 000"],
  ["LK", "Шри-Ланка", "94"],
  ["SD", "Судан", "249"],
  ["SR", "Суринам", "597"],
  ["SE", "Швеция", "46"],
  ["CH", "Швейцария", "41"],
  ["SY", "Сирия", "963"],
  ["TW", "Тайвань", "886"],
  ["TZ", "Танзания", "255"],
  ["TH", "Таиланд", "66"],
  ["TL", "Восточный Тимор", "670"],
  ["TG", "Того", "228"],
  ["TO", "Тонга", "676"],
  ["TT", "Тринидад и Тобаго", "1868"],
  ["TN", "Тунис", "216"],
  ["TV", "Тувалу", "688"],
  ["UG", "Уганда", "256"],
  ["UY", "Уругвай", "598"],
  ["VU", "Вануату", "678"],
  ["VA", "Ватикан", "379"],
  ["VE", "Венесуэла", "58"],
  ["VN", "Вьетнам", "84"],
  ["YE", "Йемен", "967"],
  ["ZM", "Замбия", "260"],
  ["ZW", "Зимбабве", "263"],
].sort((a, b) => a[1].localeCompare(b[1], "ru"));

// Любые цифры, если маски для страны нет
const ANY_DIGITS_MASK = /^\d{0,14}$/;

/** Все страны: сначала частые (Казахстан первый — по умолчанию), потом остальные по алфавиту. */
export const COUNTRIES = [...POPULAR, ...OTHERS].map(([iso, name, code, mask]) => ({
  iso,
  name,
  code,
  mask: mask || ANY_DIGITS_MASK,
  flag: toFlag(iso),
}));

export const DEFAULT_COUNTRY = COUNTRIES[0];

/**
 * Страна по телефонному коду. У нескольких стран код общий (+7 — Казахстан и Россия, +1 — США и Канада),
 * поэтому если пользователь уже выбрал одну из них (preferIso), оставляем её.
 */
export const findCountry = (code, preferIso) => {
  const matches = COUNTRIES.filter((c) => c.code === String(code ?? ""));
  return matches.find((c) => c.iso === preferIso) || matches[0] || DEFAULT_COUNTRY;
};

// Сколько цифр требует маска ("000 000 0000" → 10). Для стран без маски — null
const maskDigits = (mask) => (typeof mask === "string" ? (mask.match(/0/g) || []).length : null);

/**
 * Проверка номера. phone — полный номер с кодом страны (77001234567).
 * Возвращает текст ошибки или null, если номер подходит.
 */
export const validatePhone = (phone, countryCode) => {
  const country = findCountry(countryCode);
  const digits = String(phone || "").replace(/\D/g, "");
  const local = digits.startsWith(country.code) ? digits.slice(country.code.length) : digits;

  if (!local) return "Введите номер телефона";

  const required = maskDigits(country.mask);
  if (required !== null) {
    return local.length === required ? null : `Номер должен содержать ${required} цифр после +${country.code}`;
  }
  return local.length >= 6 && local.length <= 14 ? null : "Проверьте номер телефона";
};
